<template>
  <div class="fieldsContainer">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'fieldsContainer',
  props: {
    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<style>
.fieldsContainer {
  display: flex;
  flex-flow: row nowrap;
  padding: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/form/fieldsContainer.vue